import { render, staticRenderFns } from "./ModalEditCourseCategory.vue?vue&type=template&id=0a916616&scoped=true&"
import script from "./ModalEditCourseCategory.vue?vue&type=script&lang=js&"
export * from "./ModalEditCourseCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditCourseCategory.vue?vue&type=style&index=0&id=0a916616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a916616",
  null
  
)

export default component.exports